<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 21 20"
    fill="currentColor"
  >
    <path
      d="M19.1992 18.8374H18.5742V9.26783L10.332 4.0528L2.08984 9.2678V18.8374H1.46484C1.14125 18.8374 0.878906 19.0997 0.878906 19.4233C0.878906 19.7469 1.14125 20.0093 1.46484 20.0093H19.1992C19.5228 20.0093 19.7852 19.7469 19.7852 19.4233C19.7852 19.0997 19.5228 18.8374 19.1992 18.8374ZM14.7975 13.9064L10.7452 17.9361C10.6309 18.0497 10.4814 18.1065 10.332 18.1065C10.1826 18.1065 10.0332 18.0497 9.91887 17.9361L5.86773 13.9076C4.68309 12.723 4.68309 10.7972 5.86656 9.61377C7.05012 8.43033 8.97578 8.43029 10.1592 9.61377L10.332 9.78658L10.5048 9.61377C11.6883 8.43033 13.6139 8.43026 14.7975 9.61377C15.981 10.7972 15.981 12.723 14.7975 13.9064Z"
      fill="currentColor"
    />
    <path
      d="M11.3316 10.4424L10.7445 11.0296C10.5157 11.2583 10.1448 11.2583 9.9159 11.0296L9.32875 10.4424C8.60219 9.71588 7.42 9.71588 6.69336 10.4424C5.9668 11.169 5.9668 12.3512 6.69336 13.0778L10.3302 16.6943L13.9682 13.0767C14.6936 12.3513 14.6936 11.169 13.9671 10.4424C13.2404 9.71584 12.0582 9.71592 11.3316 10.4424ZM11.2286 13.9621H10.9161V14.2746C10.9161 14.5981 10.6538 14.8605 10.3302 14.8605C10.0066 14.8605 9.74426 14.5981 9.74426 14.2746V13.9621H9.43176C9.10816 13.9621 8.84582 13.6997 8.84582 13.3762C8.84582 13.0526 9.10816 12.7902 9.43176 12.7902H9.74426V12.4777C9.74426 12.1541 10.0066 11.8918 10.3302 11.8918C10.6538 11.8918 10.9161 12.1541 10.9161 12.4777V12.7902H11.2286C11.5522 12.7902 11.8146 13.0526 11.8146 13.3762C11.8146 13.6997 11.5522 13.9621 11.2286 13.9621Z"
      fill="currentColor"
    />
    <path
      d="M20.0594 6.04726L10.6454 0.0908508C10.454 -0.0302429 10.21 -0.0302429 10.0188 0.0908508L0.604688 6.04726C0.434922 6.15468 0.332031 6.34152 0.332031 6.54241V7.9048C0.332031 8.37706 0.852773 8.66378 1.25188 8.41128L10.0188 2.86433C10.2101 2.74327 10.454 2.74327 10.6454 2.86433L19.4122 8.41128C19.8113 8.66378 20.332 8.37702 20.332 7.9048V6.54241C20.332 6.34152 20.2291 6.15468 20.0594 6.04726Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    currentColor: {
      type: String,
      default: "#9B237B",
    },
  },
};
</script>
